module.exports = "<basicplans-page></basicplans-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/basics.html
// module id = 1663
// module chunks = 0